import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Theme, alpha } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';

const FADE_STOP_IN_PERCENT = 24.52;

const getFadeBackground = (theme: Theme, isOnWorkspaceSurface: boolean) => {
  const surface = isOnWorkspaceSurface
    ? theme.palette.custom.layout.workspace
    : theme.palette.background.default;

  return `linear-gradient(180deg, ${alpha(surface, 0)} 0%, ${alpha(surface, 0.8)} ${FADE_STOP_IN_PERCENT}%, ${surface} 50%, ${surface} 100%)`;
};

const BOTTOM_SPACING = 3;

interface RachelDisclaimerProps {
  hasFade: boolean;
  isOnWorkspaceSurface: boolean;
}

const RachelDisclaimer = ({ hasFade, isOnWorkspaceSurface }: RachelDisclaimerProps) => {
  const { translate } = useTranslation();

  return (
    <Box
      sx={(theme) => ({
        position: 'relative',
        zIndex: 1,
        pointerEvents: 'none',
        flexShrink: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing(3, 0, isOnWorkspaceSurface ? BOTTOM_SPACING : 0),
        marginTop: theme.spacing(-3),
        background: hasFade ? getFadeBackground(theme, isOnWorkspaceSurface) : undefined,
      })}
    >
      <Typography variant="micro2" noWrap sx={{ color: 'text.disabled' }}>
        {translate(LangEnum.RACHEL_DISCLAIMER)}
      </Typography>
    </Box>
  );
};

export default RachelDisclaimer;
